import React, { useState, useEffect } from 'react';
import { FaGithub, FaReact, FaNodeJs, FaPython, FaDatabase, FaJs, FaCss3Alt, FaHtml5, FaAws, FaDocker } from 'react-icons/fa';
import { SiMongodb, SiExpress, SiFirebase, SiRedux, SiTensorflow, SiFlask, SiStripe, SiPostgresql, SiSocketdotio, SiNextdotjs, SiFlutter } from 'react-icons/si';
import '../styles/Projects.css';

const dummyProjects = [
  {
    
    _id: '1',
    title: 'WellScope',
    description: 'Built WellScope — an AI-powered mental health monitoring platform — as a full-stack MERN application integrated with a RoBERTa-based NLP model for real-time emotion detection. Developed a scalable microservice architecture using React.js, Node.js, FastAPI, and MongoDB with features like journal-based mood tracking, dashboard analytics, secure authentication, and emotional trend visualization.',
    technologies: ['React', 'Node.js', 'SupaBase', 'Express', 'FastAPI', 'PostgreSQL',],
    imageUrl: '/wellscope.png',
    projectUrl: 'https://wellscope.vercel.app/',
    githubUrl: 'https://github.com/Atharv-Untwale/wellscope'
  },
  {
    
    _id: '2',
    title: 'MU-ACM Website',
    description: 'Built the official website for the ACM Student Chapter at Medi-Caps University from scratch as both President and sole developer. Designed and developed a full-stack MERN application with a cyberpunk-inspired UI featuring a terminal boot sequence, starfield parallax, and scroll-reveal animations. The platform serves as the chapters digital home — showcasing events, team members, achievements, and a gallery — with a custom admin dashboard for content management backed by Firebase Firestore and JWT-based authentication. Deployed on Vercel (frontend) and Render (backend)',
    technologies: ['React', 'Node.js', 'SupaBase', 'Express'],
    imageUrl: '/mu-acm.png',
    projectUrl: 'https://mu-acm.vercel.app/',
    githubUrl: 'https://github.com/Atharv-Untwale/mu-acm'
  },
  {
    _id: '3',
    title: 'BlockChain Simulator',
    description: 'The Blockchain Simulator is an interactive web application built using React to demonstrate the core working principles of blockchain technology in a simplified and visual manner. The project is designed as a learning and demonstration tool, helping users understand how transactions, blocks, hashing, and mining work together to maintain blockchain integrity.',
    technologies: ['React'],
    imageUrl: '/Blockchain Simulator.png',
    projectUrl: 'https://blockchain-simulator-murex.vercel.app/',
    githubUrl: 'https://github.com/Atharv-Untwale/Blockchain-Simulator'
  },
  {
    _id: '4',
    title: 'GitRoast',
    description: 'Git Roast is a developer-focused platform designed to help programmers grow through honest, constructive feedback. It provides a space where developers can showcase their projects, share their code, and receive detailed reviews from peers, mentors, and the wider tech community. Unlike traditional platforms that often rely on surface-level appreciation, Git Roast promotes meaningful technical discussions that focus on improving code quality, optimizing architecture, and strengthening problem-solving approaches.',
    technologies: ['React', 'TalwindCSS'],
    imageUrl: '/GitRoast.png',
    projectUrl: 'https://git-roast-pi.vercel.app/',
    githubUrl: 'https://github.com/Atharv-Untwale/GitRoast'
  },
  {
    _id: '5',
    title: 'Div-Trek',
    description: 'A cross-platform mobile task management application with real-time synchronization across devices using Firebase. Features include collaborative task boards, priority management with color coding, deadline reminders with push notifications, file attachments, commenting system, and offline mode with automatic sync when online. Users can create teams, assign tasks, track progress, and visualize productivity with detailed analytics.',
    technologies: ['React', 'TalwindCSS', 'Nodejs'],
    imageUrl: '/DivTrek.png',
    projectUrl: 'https://divtrek.vercel.app/#home',
    githubUrl: 'https://github.com/Atharv-Untwale/Div-Trek'
  },
];

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [flippedCards, setFlippedCards] = useState({});

  useEffect(() => {
    setProjects(dummyProjects);
    setLoading(false);
  }, []);

  const getTechIcon = (tech) => {
    const techLower = tech.toLowerCase();
    if (techLower.includes('react')) return <FaReact />;
    if (techLower.includes('node')) return <FaNodeJs />;
    if (techLower.includes('python')) return <FaPython />;
    if (techLower.includes('mongodb')) return <SiMongodb />;
    if (techLower.includes('express')) return <SiExpress />;
    if (techLower.includes('firebase')) return <SiFirebase />;
    if (techLower.includes('redux')) return <SiRedux />;
    if (techLower.includes('tensorflow')) return <SiTensorflow />;
    if (techLower.includes('flask')) return <SiFlask />;
    if (techLower.includes('stripe')) return <SiStripe />;
    if (techLower.includes('postgres')) return <SiPostgresql />;
    if (techLower.includes('socket')) return <SiSocketdotio />;
    if (techLower.includes('next')) return <SiNextdotjs />;
    if (techLower.includes('flutter')) return <SiFlutter />;
    if (techLower.includes('javascript')) return <FaJs />;
    if (techLower.includes('css') || techLower.includes('tailwind')) return <FaCss3Alt />;
    if (techLower.includes('html')) return <FaHtml5 />;
    if (techLower.includes('aws')) return <FaAws />;
    if (techLower.includes('docker')) return <FaDocker />;
    if (techLower.includes('database')) return <FaDatabase />;
    return <span className="tech-letter">{tech.charAt(0)}</span>;
  };

  const handleCardClick = (projectId) => {
    setFlippedCards(prev => ({
      ...prev,
      [projectId]: !prev[projectId]
    }));
  };

  if (loading) {
    return (
      <section id="projects" className="projects">
        <div className="projects-container">
          <h2 className="section-title">My Projects</h2>
          <div className="loading">Loading projects...</div>
        </div>
      </section>
    );
  }

  return (
    <section id="projects" className="projects">
      <div className="projects-container">
        <h2 className="section-title">My Projects</h2>

        <div className="projects-grid">
          {projects.map((project) => (
            <div
              key={project._id}
              className={`project-card-wrapper ${flippedCards[project._id] ? 'flipped' : ''}`}
            >
              <div className="project-card-inner">
                {/* Front Side */}
                <div className="project-card project-card-front">
                  <div className="project-image-container">
                    <img
                      src={project.imageUrl}
                      alt={project.title}
                      className="project-image"
                    />
                    <div className="project-title-overlay">
                      <h3 className="project-title">{project.title}</h3>
                    </div>
                  </div>

                  <div className="project-content">
                    <div className="project-tech-icons">
                      {project.technologies.map((tech, index) => (
                        <span key={index} className="tech-icon" title={tech}>
                          {getTechIcon(tech)}
                        </span>
                      ))}
                    </div>

                    <div className="project-actions">
                      {project.projectUrl && (
                        <a
                          href={project.projectUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="project-btn btn-primary"
                          onClick={(e) => e.stopPropagation()}
                        >
                          View Live
                        </a>
                      )}
                      {project.githubUrl && (
                        <a
                          href={project.githubUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="project-btn btn-secondary"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <FaGithub /> GitHub
                        </a>
                      )}
                    </div>

                    <div className="click-hint" onClick={() => handleCardClick(project._id)}>
                      <span>Click to know more →</span>
                    </div>
                  </div>
                </div>

                {/* Back Side */}
                <div className="project-card project-card-back" onClick={() => handleCardClick(project._id)}>
                  <div className="card-back-content">
                    <h3 className="back-title">{project.title}</h3>
                    <div className="back-description">
                      <p>{project.description}</p>
                    </div>
                    <div className="click-hint-back">
                      <span>← Click to go back</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="view-all-container">
          <a href="/all-projects" className="view-all-btn">
            View All Projects
          </a>
        </div>
      </div>
    </section>
  );
};

export default Projects;